{
  "columns": [],
  "buttons": [],
  "apiDetails": "mass-adjustment-list.json",
  "pageName": "timeSheetBatchResultList",
  "orderByColumn": ["modifiedDate"],
  "orderBy": ["desc"]
}
